import { createFileRoute } from '@tanstack/react-router'
import { LogbookPage } from 'pages/logbook/LogbookPage'

export const Route = createFileRoute('/logbook/')({
  component: LogbookPage,
  staticData: {
    title: 'Logbook',
  },
})
